import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ManageVendors } from "components/manage-vendors/manage-vendors.jsx";
import {
  fetchVendorsAction,
  selectVendorsAction,
  deselectVendorsAction,
  addVendorRulesAction,
  startAddVendorRulesModeAction,
  endAddVendorRulesModeAction,
  selectCategoryForRuleAction,
  deleteIncludeRuleAction,
  orderVendorsAction,
  startMergeVendorsModeAction,
  endMergeVendorsModeAction,
  selectMergeVendorAction,
  mergeVendorsAction
} from "actions/vendors-actions";
import { trackPageAction } from "actions/shared/tracking-actions";
import { Loading } from "components/common/loading";

class ManageVendorsPage extends React.Component {
  componentWillMount() {
    this.props.init();
    this.props.trackPage();
  }

  render() {
    if (this.props.isLoading) {
      return <Loading />;
    }
    return <ManageVendors { ...this.props } />;
  }
}

ManageVendorsPage.propTypes = {
  init: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  trackPage: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  categories: state.categories.categories,
  isAddVendorRulesLoading: state.vendors.isAddVendorRulesLoading,
  isAddVendorRulesMode: state.vendors.isAddVendorRulesMode,
  isLoading: state.vendors.isLoading,
  isMergeVendorsLoading: state.vendors.isMergeVendorsLoading,
  isMergeVendorsMode: state.vendors.isMergeVendorsMode,
  orderBy: state.vendors.orderBy,
  orderDirection: state.vendors.orderDirection,
  selectedCategory: state.vendors.selectedCategory,
  selectedVendorIds: state.vendors.selectedVendorIds,
  selectedVendor: state.vendors.selectedVendor,
  slug: state.app.selectedAccount.slug,
  vendors: state.vendors.vendors
});

const mapDispatchToProps = (dispatch) => ({
  init: () => dispatch(fetchVendorsAction()),
  trackPage: () => dispatch(trackPageAction("Manage Vendors page")),
  onAddVendorRules: () => dispatch(addVendorRulesAction()),
  onDeleteIncludeRule: (accountId, category, vendor) => dispatch(deleteIncludeRuleAction(accountId, category, vendor)),
  onDeselectVendors: (ids) => dispatch(deselectVendorsAction(ids)),
  onEndAddVendorRulesMode: () => dispatch(endAddVendorRulesModeAction()),
  onEndMergeVendorsMode: () => dispatch(endMergeVendorsModeAction()),
  onMergeVendors: (accountId, vendor, vendors) => dispatch(mergeVendorsAction(accountId, vendor, vendors)),
  onOrderBy: (column) => dispatch(orderVendorsAction(column)),
  onSelectCategory: (category) => dispatch(selectCategoryForRuleAction(category)),
  onSelectMergeVendor: (vendor) => dispatch(selectMergeVendorAction(vendor)),
  onSelectVendors: (ids) => dispatch(selectVendorsAction(ids)),
  onStartAddVendorRulesMode: () => dispatch(startAddVendorRulesModeAction()),
  onStartMergeVendorsMode: () => dispatch(startMergeVendorsModeAction())
});

export const ManageVendorsContainer = connect(mapStateToProps, mapDispatchToProps)(ManageVendorsPage);



// WEBPACK FOOTER //
// ./src/js/containers/manage-vendors-container.jsx